import { Client, Room } from "colyseus.js";
import type { WorldState } from "@ember/shared";
import { WS_URL } from "../config.js";
import { getToken } from "./api.js";

export async function connectToWorld(characterId?: string): Promise<Room<WorldState>> {
  const client = new Client(WS_URL);
  const token = getToken();
  const room = await client.joinOrCreate<WorldState>("world", { token, characterId });
  return room;
}
